import { render, staticRenderFns } from "./GeometryViz.vue?vue&type=template&id=36074a84&scoped=true"
import script from "./GeometryViz.vue?vue&type=script&lang=js"
export * from "./GeometryViz.vue?vue&type=script&lang=js"
import style0 from "./GeometryViz.vue?vue&type=style&index=0&id=36074a84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36074a84",
  null
  
)

export default component.exports